import { Component, Injector, Input, OnInit, forwardRef } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { SettingScopes, NameValueDto, TimingServiceProxy } from '@shared/service-proxies/service-proxies';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    standalone: false,
    selector: 'timezone-combo',
    template:
    `
    <ng-select class="width-percent-100" [formControl]="selectedTimeZone" [ngClass]="{'invalid-border': isShowError }" [searchable]="true" [clearSearchOnAdd]="true" bindLabel="name"  placeholder="{{'Selecttimezone' | localize}}" dropdownPosition="bottom"   [closeOnSelect]="false" [isOpen]="isSelectTimeOpen" (click)="switchTime()"  (clickOutside)="closeDropdown()" required>
        <ng-option *ngFor="let timeZone of timeZones" [value]="timeZone.value" required>{{timeZone.name}}</ng-option>

    </ng-select>`,

    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TimeZoneComboComponent),
        multi: true,
    }]
})
export class TimeZoneComboComponent extends AppComponentBase implements OnInit, ControlValueAccessor {
    constructor(
        private _timingService: TimingServiceProxy,
        injector: Injector) {
        super(injector);
    }

    @Input() defaultTimezoneScope: SettingScopes;
    @Input() isShowError: any = false;

   preStoredTimeZones = [
        { name: this.l("DefaultUTC"),value: "Default" },
        { name: this.l("Kabul"),value:"Afghanistan Standard Time"},
        { name: this.l("Alaska"),value:"Alaskan Standard Time" },
        { name: this.l("AleutianIslands"),value:"Aleutian Islands"},
        { name: this.l("BarnaulGornoAltaysk"), value:"Altai Standard Time"},
        { name: this.l("KuwaitRiyadh"),value:"Arab Standard Time"},
        { name: this.l("AbuDhabiMuscat"),value:"Arabian Standard Time" },
        { name: this.l("Baghdad"),value:"Arabic Standard Time"},
        { name: this.l("CityofBuenosAires"), value:"Argentina Standard Time"},
        { name: this.l("AstrakhanUlyanovsk"),value: "Astrakhan Standard Time" },
        { name: this.l("AtlanticTime(Canada)"), value:"Atlantic Standard Time"},
        { name: this.l("Darwin"), value:"AUS Central Standard Time"},
        { name: this.l("Eucla"),value:"Aus Central W. Standard Time"},
        { name: this.l("CanberraMelbourneSydney"),value:"AUS Eastern Standard Time"},
        { name: this.l("Baku"), value:"Aus Central W. Standard Time"},
        { name: this.l("Salvador"),value: "Bahia Standard Time" },
        { name: this.l("Dhaka"), value:"Bangladesh Standard Time"},
        { name: this.l("Minsk"), value:"Belarus Standard Time"},
        { name: this.l("BougainvilleIsland"),value: "Bougainville Standard Time" },
        { name: this.l("Saskatchewan"), value:"Canada Central Standard Time"},
        { name: this.l("CaboVerdeIs"), value:"Cape Verde Standard Time"},
        { name: this.l("Yerevan"), value:"Caucasus Standard Time"},
        { name: this.l("Adelaide"), value:"Cen. Australia Standard Time"},
        { name: this.l("CentralAmerica"),value:"Central America Standard Time"},
        { name: this.l("Astana"), value:"Central Asia Standard Time"},
        { name: this.l("Cuiaba"), value:"Central Brazilian Standard Time"},
        { name: this.l("BelgradeBratislavaBudapestLjubljanaPrague"),value: "Central Europe Standard Time" },
        { name: this.l("SarajevoSkopjeWarsawZagreb"), value:"Central European Standard Time"},
        { name: this.l("SolomonIsNewCaledonia"), value:"Central Pacific Standard Time"},
        { name: this.l("CentralTimeUSCanada"),value:"Central Standard Time"},
        { name: this.l("GuadalajaraMexicoCityMonterrey"),value:"Central Standard Time (Mexico)"},
        { name: this.l("ChathamIslands"), value:"Chatham Islands Standard Time"},
        { name: this.l("BeijingChongqingHongKongUrumqi"),value: "China  Standard Time" },
        { name: this.l("Havana"), value:"Cuba Standard Time"},
        { name: this.l("InternationalDateLineWest"), value:"Dateline Standard Time"},
        { name: this.l("Nairobi"),value: "E. Africa Standard Time" },
        { name: this.l("Brisbane"), value:"E. Australia Standard Time"},
        { name: this.l("Chisinau"), value:"E. Europe Standard Time"},
        { name: this.l("Brasilia"),value: "E. South America Standard Time" },
        { name: this.l("EasterIsland"), value:"Easter Island Standard Time"},
        { name: this.l("EasternTimeUSCanada"),value:"Eastern Standard Time" },
        { name: this.l("Chetumal"), value:"Eastern Standard Time (Mexico)"},
        { name: this.l("Cairo"), value:"Egypt Standard Time"},
        { name: this.l("Ekaterinburg"),value:"Ekaterinburg Standard Time" },
        { name: this.l("Fiji"), value:"Fiji Standard Time"},
        { name: this.l("HelsinkiKyivRigaSofiaTallinnVilnius"), value:"FLE Standard Time"},
        { name: this.l("Tbilisi"),value: "Georgian Standard Time" },
        { name: this.l("DublinEdinburghLisbonLondon"), value:"GMT Standard Time"},
        { name: this.l("Greenland"), value:"Greenland Standard Tim"},
        { name: this.l("MonroviaReykjavik"),value:"Greenwich Standard Time"},
        { name: this.l("AthensBucharest"),value:"GTB Standard Time"},
        { name: this.l("Haiti"), value:"Haiti Standard Time"},
        { name: this.l("Hawaii"),value: "Hawaiian Standard Time" },
        { name: this.l("ChennaiKolkataMumbaiNewDelhi"), value:"India Standard Time"},
        { name: this.l("Tehran"), value:"Iran Standard Time"},
        { name: this.l("Jerusalem"),value: "Israel Standard Time" },
        { name: this.l("Amman"), value:"Jordan Standard Time"},
        { name: this.l("Kaliningrad"), value:"Kaliningrad Standard Time"},
        { name: this.l("PetropavlovskKamchatskyOld"), value:"Kamchatka Standard Time"},
        { name: this.l("Seoul"), value:"Korea Standard Time"},
        { name: this.l("Tripoli"),value:"Libiya Standard Time"},
        { name: this.l("KiritimatiIsland"), value:"Line Islands Standard Time"},
        { name: this.l("LordHoweIsland"), value:"Lord Howe Standard Time"},
        { name: this.l("Magadan"),value: "Magadan Standard Time" },
        { name: this.l("PuntaArenas"), value:"Magallanes Standard Time"},
        { name: this.l("MarquesasIslands"), value:"Marquesas Standard Time"},
        { name: this.l("PortLouis"),value:"Mauritius Standard Time"},
        { name: this.l("MidAtlanticOld"),value:"Mid-Atlantic Standard Time"},
        { name: this.l("Beirut"), value:"Middle East Standard Time"},
        { name: this.l("Montevideo"),value: "Montevideo Standard Time" },
        { name: this.l("Casablanca"), value:"Morocco Standard Time"},
        { name: this.l("MountainTimeUSCanada"), value:"Mountain Standard Time"},
        { name: this.l("ChihuahuaLaPazMazatlan"),value:"Mountain Standard Time (Mexico)" },
        { name: this.l("Yangon"), value:"Myanmar Standard Time"},
        { name: this.l("Novosibirsk"), value:"N. Central Asia Standard Time"},
        { name: this.l("Windhoek"), value:"Namibia Central Standard Time"},
        { name: this.l("Kathmandu"),value:"Nepal Standard Time" },
        { name: this.l("AucklandWellington"), value:"New Zealand Standard Time"},
        { name: this.l("Newfoundland"), value:"Newfoundland Standard Time"},
        { name: this.l("NorfolkIsland"),value:"Norfolk Standard Time"},
        { name: this.l("Irkutsk"),value:"North Asia East Standard Time"},
        { name: this.l("Krasnoyarsk"), value:"North Asia Standard Time"},
        { name: this.l("Pyongyang"),value:"North Korea Standard Time" },
        { name: this.l("Omsk"), value:"Omsk Standard Time"},
        { name: this.l("Santiago"), value:"Pacific SA Standard Time"},
        { name: this.l("PacificTimeUSCanada"),value: "Pacific Standard Time" },
        { name: this.l("BajaCalifornia"), value:"Pacific Standard Time (Mexico)"},
        { name: this.l("IslamabadKarachi"), value:"Pakistan Standard Time"}, 
        { name: this.l("Asuncion"), value:"Paraguay Standard Time"},
        { name: this.l("Qyzylorda"),value:"Qyzylorda Standard Time" },
        { name: this.l("BrusselsCopenhagenMadridParis"),value : "Romance Standard Time"},
        { name: this.l("Chokurdakh"), value:"Russia Time Zone 10"},
        { name: this.l("AnadyrPetropavlovskKamchatsky"),value:"Russia Time Zone 11"},
        { name: this.l("IzhevskSamara"),value:"Russia Time Zone 3"},
        { name: this.l("MoscowStPetersburg"), value:"Russian Standard Time"},
        { name: this.l("CayenneFortaleza"),value:"SA Eastern Standard Time" },
        { name: this.l("BogotaLimaQuitoRioBranco"), value:"SA Pacific Standard Time"},
        { name: this.l("GeorgetownLaPazManausSanJuan"), value:"SA Western Standard Time"},
        { name: this.l("SaintPierreandMiquelon"),value: "Saint Pierre Standard Time" },
        { name: this.l("Sakhalin"), value:"Sakhalin Standard Time"},
        { name: this.l("Samoa"), value:"Samoa Standard Time"},
        { name: this.l("SaoTome"),value : "Sao Tome Standard Time"},
        { name: this.l("Saratov"), value:"Saratov Standard Time"},
        { name: this.l("BangkokHanoiJakarta"),value:"SE Asia Standard Time"},
        { name: this.l("KualaLumpurSingapore"),value:"Singapore Standard Time"},
        { name: this.l("HararePretoria"), value:"South Africa Standard Time"},
        { name: this.l("SriJayawardenepura"),value:"Sri Lanka Standard Time" },
        { name: this.l("Khartoum"), value:"Sudan Standard Time"},
        { name: this.l("Damascus"), value:"Syria Standard Time"},
        { name: this.l("Taipei"),value: "Taipei Standard Time" },
        { name: this.l("Hobart"), value:"Tasmania Standard Time"},
        { name: this.l("Araguaina"), value:"Tocantins Standard Time"}, 
        { name: this.l("OsakaSapporoTokyo"),value : "Tokyo Standard Time"},
        { name: this.l("Tomsk"), value:"Tomsk Standard Time"},
        { name: this.l("Nukualofa"),value:"Tonga Standard Time"},
        { name: this.l("Chita"),value:"Transbaikal Standard Time"},
        { name: this.l("Istanbul"), value:"Turkey Standard Time"},
        { name: this.l("TurksandCaicos"),value:"Turks And Caicos Standard Time" },
        { name: this.l("Ulaanbaatar"), value:"Ulaanbaatar Standard Time"},
        { name: this.l("IndianaEast"), value:"US Eastern Standard Time"},
        { name: this.l("Arizona"),value: "US Mountain Standard Time" },
        { name: this.l("CoordinatedUniversalTime"), value:"UTC"},
        { name: this.l("CoordinatedUniversalTime02"), value:"UTC-02"},
        { name: this.l("CoordinatedUniversalTime08"),value : "UTC-08"},
        { name: this.l("CoordinatedUniversalTime09"), value:"UTC-09"},
        { name: this.l("CoordinatedUniversalTime11"),value:"UTC-11"},
        { name: this.l("CoordinatedUniversalTime12"),value:"UTC+12"},
        { name: this.l("CoordinatedUniversalTime13"), value:"UTC+13"},
        { name: this.l("AmsterdamBerlinBernRomeStockholmVienna"), value:"W. Europe Standard Time"},
        { name: this.l("Caracas"),value:"Venezuela Standard Time" },
        { name: this.l("Vladivostok"), value:"Vladivostok Standard Time"},
        { name: this.l("Volgograd"), value:"Volgograd Standard Time"},
        { name: this.l("Perth"),value: "W. Australia Standard Time"},
        { name: this.l("Hovd"), value:"W. Mongolia Standard Time"},
        { name: this.l("AshgabatTashkent"), value:"West Asia Standard Time"},
        { name: this.l("GazaHebron"), value:"West Bank Standard Time"},
        { name: this.l("GuamPortMoresby"),value:"West Pacific Standard Time"},
        { name: this.l("Yakutsk"), value:"Yakutsk Standard Time"},
        { name: this.l("Yukon"), value:"Yukon Standard Time"},

    ];
    timeZones: NameValueDto[] = [];
    selectedTimeZone = new FormControl('');
    isSelectTimeOpen = false;

    onTouched: any = () => { };
    ngOnInit(): void {
        let self = this;
        self._timingService.getTimezones(self.defaultTimezoneScope).subscribe(result => {
           
           self.timeZones =result.items;
        
        });        

    }
    removeUTCOffset(data: NameValueDto[]) {
        const pattern = /\s*\((?:UTC[\+\-]\d{2}:\d{2})\)\s*|\(UTC\)\s*/;
    
        return data.map((item) => {
          const modifiedName = item.name.replace(pattern, '');
          return new NameValueDto({name: modifiedName, value: item.value });
        });
    }
    sortData(data: NameValueDto[]): NameValueDto[] {
        const sortedData = data.slice(); // Create a shallow copy to avoid modifying the original data
        sortedData.sort((a, b) => {
          return a.name.localeCompare(b.name); // Sort the rest alphabetically
        });
        return sortedData;
      }
    writeValue(obj: any): void {
        if (this.selectedTimeZone) {
            this.selectedTimeZone.setValue(obj);
        }
    }
    registerOnChange(fn: any): void {
        this.selectedTimeZone.valueChanges.subscribe(fn);
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    switchTime() {
       this.isSelectTimeOpen = !this.isSelectTimeOpen;
    }
    closeDropdown() {
        this.isSelectTimeOpen = false;
    }
    setDisabledState?(isDisabled: boolean): void {
        if (isDisabled) {
            this.selectedTimeZone.disable();
        } else {
            this.selectedTimeZone.enable();
        }
    }

    //** Provide concated timezone as per the requirement on MAC and Window App
    getConcatedTimeZone(input: string): string {        
        let x = '';
        this.preStoredTimeZones.find((o, i) => {
            if (o.value == input) {
                x = (this.preStoredTimeZones[i].name + ' - ' + this.preStoredTimeZones[i].value);               
            }
        });
        return x;
    }

    //** Provide seprated timezone as per the requirement on MAC and Window App
    getSeperatedTimeZone(input: string): string {
        if(input){
            let result = input?.split(' - ');
            if (result?.length > 1)
                return result[1];
            else
                return null;
        }else{
            return null;
        }

    }
}
